// Labels for the categories and priorities the server's schema allows
// (utils/mailAssistant/schema.js). Keys of the "mail" namespace.
export const CATEGORY_LABELS = {
  customer_inquiry: "Customer inquiry",
  quote_request: "Quote request",
  order: "Order",
  appointment: "Appointment",
  complaint: "Complaint",
  invoice_received: "Invoice",
  payment_reminder: "Payment reminder",
  supplier_offer: "Supplier offer",
  contract: "Contract",
  job_application: "Job application",
  authority: "Authority",
  bank_insurance: "Bank / insurance",
  internal: "Internal",
  newsletter: "Newsletter",
  notification: "Notification",
  spam_phishing: "Spam / phishing",
  personal: "Personal",
  other: "Other"
};

export const PRIORITY_LABELS = {
  urgent: "Urgent",
  high: "High",
  normal: "Normal",
  low: "Low"
};

export const PRIORITY_COLORS = {
  urgent: "red",
  high: "orange",
  normal: "blue",
  low: "default"
};

export const PRIORITY_RANK = { urgent: 0, high: 1, normal: 2, low: 3 };

// Mirrors keyOf() in controllers/mailAssistantController.js: the Message-ID survives a
// move to another folder, the UID does not.
export const analysisKey = (folder, message) =>
  message?.messageId ? `mid:${String(message.messageId).trim()}` : `uid:${folder}:${message?.uid}`;
